// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3-K2Z","row":"row-2Zgih","name":"name-13CuG","doc":"doc-18qhx","expiration":"expiration-3Qrjj"};